import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class PreferenceSetting {
  // 查询用户偏好设置
  static async getPreferenceSetting() {
    const [err, res] = await To(wizStandardInstance.get('/api/User_Preference_Setting'))
    return Callback(err, res)
  }
  // 保存偏好设置
  static async savePreferenceSetting(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/User_Preference_Setting', payload))
    return Callback(err, res)
  }
}
